import { css } from "@linaria/core";

import { fonts } from "./fonts";
import { makeTypographyToken } from "../css/token.typography";
import { units } from "../css-tokens/units";
import { makeBreakpoints } from "../css/maker.breakpoints";

const heading1 = makeTypographyToken("--heading-1", {
  fontFace: fonts.body.fontFaces["extra-bold"],
  fontSize: units.font.px(55),
  lineHeight: 1,
});

const heading2 = makeTypographyToken("--heading-2", {
  fontFace: fonts.body.fontFaces["extra-bold"],
  fontSize: units.font.px(35),
  lineHeight: 1,
});

const heading3 = makeTypographyToken("--heading-3", {
  fontFace: fonts.body.fontFaces["extra-bold"],
  fontSize: units.font.px(28),
  lineHeight: 1.07143,
});

const heading4 = makeTypographyToken("--heading-4", {
  fontFace: fonts.body.fontFaces["extra-bold"],
  fontSize: units.font.px(20),
  lineHeight: 1.15,
});

const heading5 = makeTypographyToken("--heading-5", {
  fontFace: fonts.body.fontFaces.bold,
  fontSize: units.font.px(16),
  lineHeight: 1.1875,
});

const heading6 = makeTypographyToken("--heading-6", {
  fontFace: fonts.body.fontFaces.medium,
  fontSize: units.font.px(13),
  lineHeight: 1.23077,
});

const summary = makeTypographyToken("--summary", {
  fontFace: fonts.body.fontFaces.light,
  fontSize: units.font.px(22),
  lineHeight: 1.36364,
});

const body = makeTypographyToken("--body", {
  fontFace: fonts.body,
  fontSize: units.font.px(18),
  lineHeight: 1.5,
  letterSpacing: "0.01em",
  wordSpacing: "0.01em",
});

const figtree = makeTypographyToken("--figtree", {
  fontFace: fonts.figtree,
  fontSize: units.font.px(18),
  lineHeight: 1.5,
  letterSpacing: "0.01em",
  wordSpacing: "0.01em",
});

const detail = makeTypographyToken("--detail", {
  fontFace: fonts.body,
  fontSize: units.font.px(15),
  lineHeight: 1.4667,
});

const meta = makeTypographyToken("--meta", {
  fontFace: fonts.body,
  fontSize: units.font.px(13),
  lineHeight: 1.23077,
  letterSpacing: "0.03em",
  textTransform: "uppercase",
});

export const typographies = {
  heading1,
  heading2,
  heading3,
  heading4,
  heading5,
  heading6,

  summary,
  body,
  figtree,
  detail,
  meta,
};

const breakpoints = makeBreakpoints({
  s: 0,
  m: 768,
  l: 1281,
});

// eslint-disable-next-line @typescript-eslint/no-unused-expressions
css`
  :global() {
    body[data-font-variant="dyslexie"] {
      ${heading1
        .__override({
          lineHeight: 1.25,
        })
        .toString()};
      ${heading2
        .__override({
          lineHeight: 1.25,
        })
        .toString()};
      ${heading3
        .__override({
          lineHeight: 1.23,
        })
        .toString()};
      ${heading4
        .__override({
          lineHeight: 1.44,
        })
        .toString()};
      ${heading5
        .__override({
          lineHeight: 1.23,
        })
        .toString()};
      ${heading6
        .__override({
          lineHeight: 1.18182,
        })
        .toString()};
      ${summary
        .__override({
          lineHeight: 1.77,
        })
        .toString()};
      ${body
        .__override({
          lineHeight: 2.125,
        })
        .toString()};
      ${detail
        .__override({
          lineHeight: 1.83,
        })
        .toString()};
      ${meta
        .__override({
          lineHeight: 2,
        })
        .toString()};

      @media ${breakpoints.m.toQuery()} {
        ${heading1
          .__override({
            lineHeight: 1.375,
          })
          .toString()};
      }

      @media ${breakpoints.s.toQuery()} {
        ${heading1
          .__override({
            lineHeight: 1.375,
          })
          .toString()};
        ${heading2
          .__override({
            lineHeight: 1.5,
          })
          .toString()};
        ${heading3
          .__override({
            lineHeight: 1.4,
          })
          .toString()};
        ${heading4
          .__override({
            lineHeight: 1.28,
          })
          .toString()};
        ${summary
          .__override({
            lineHeight: 1.62,
          })
          .toString()};
        ${body.__override({ lineHeight: 1.71 }).toString()};
        ${detail.__override({ lineHeight: 1.66 }).toString()};
      }
    }

    :root {
      @media ${breakpoints.m.toQuery()} {
        ${heading1
          .__override({
            fontSize: units.font.px(44),
            lineHeight: 1,
          })
          .toString()};
      }

      @media ${breakpoints.s.toQuery()} {
        ${heading1
          .__override({
            fontSize: units.font.px(44),
            lineHeight: 1,
          })
          .toString()};
        ${heading2
          .__override({
            fontSize: units.font.px(32),
            lineHeight: 1,
          })
          .toString()};
        ${heading3
          .__override({
            fontSize: units.font.px(24),
            lineHeight: 1.08333,
          })
          .toString()};
        ${heading4
          .__override({
            fontSize: units.font.px(18),
            lineHeight: 1.11111,
          })
          .toString()};
        ${heading5
          .__override({
            fontSize: units.font.px(14),
            lineHeight: 1.15385,
          })
          .toString()};
        ${heading6
          .__override({
            fontSize: units.font.px(11),
            lineHeight: 1.18182,
          })
          .toString()};
        ${summary
          .__override({
            fontSize: units.font.px(20),
            lineHeight: 1.35,
          })
          .toString()};
        ${body
          .__override({ fontSize: units.font.px(16), lineHeight: 1.4375 })
          .toString()};
        ${detail
          .__override({ fontSize: units.font.px(14), lineHeight: 1.35714 })
          .toString()};
      }
    }
  }
`;
